import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EditAlliedComponent } from '../edit-allied/edit-allied.component';

@Component({
  selector: 'app-enableorganization',
  templateUrl: './enableorganization.component.html',
  styleUrls: ['./enableorganization.component.scss']
})
export class EnableorganizationComponent {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { title: string, statusAllied: boolean },
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<EditAlliedComponent>,
  ) { }

  public closeModal(): void {
    this.dialogRef.close();
  }

}
